import { Link } from "react-router-dom";

const STAGES = [
    { label: "Pour", status: "Complete" },
    { label: "Rest", status: "In Progress" },
    { label: "Cut", status: "Pending" },
    { label: "Ship", status: "Pending" },
];

export default function CureTracker() {
    return (
        <section
            className="relative bg-forest text-cream py-16 md:py-20 overflow-hidden"
            data-testid="cure-tracker"
        >
            <div className="grain absolute inset-0 opacity-50" />
            <div className="relative max-w-6xl mx-auto px-5 md:px-10">
                <div className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <span className="divider-rule text-gold">
                            Cure Progress · Holiday 2026
                        </span>
                        <h2 className="font-serif text-4xl sm:text-5xl mt-5 leading-tight">
                            The Glow Set is{" "}
                            <span className="italic text-gold">curing.</span>
                        </h2>
                    </div>
                    <Link
                        to="/coming-soon"
                        className="text-[0.7rem] tracking-[0.3em] uppercase text-gold hover:text-cream transition-colors inline-flex items-center gap-2"
                        data-testid="cure-tracker-link"
                    >
                        View Studio Log →
                    </Link>
                </div>

                <div className="mt-10 relative">
                    <div className="absolute left-4 right-4 top-4 h-px bg-cream/15" />
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 relative">
                        {STAGES.map((s, i) => {
                            const done = s.status === "Complete";
                            const active = s.status === "In Progress";
                            return (
                                <div
                                    key={s.label}
                                    className="flex flex-col items-start"
                                    data-testid={`cure-stage-${i}`}
                                >
                                    <div
                                        className={`w-9 h-9 rounded-full flex items-center justify-center font-serif text-sm border ${
                                            done
                                                ? "bg-gold text-forest border-gold"
                                                : active
                                                  ? "border-gold text-gold animate-pulse"
                                                  : "border-cream/25 text-cream/40"
                                        }`}
                                    >
                                        {i + 1}
                                    </div>
                                    <h4 className="font-serif text-xl mt-4">
                                        {s.label}
                                    </h4>
                                    <span
                                        className={`text-[0.6rem] tracking-[0.3em] uppercase mt-1 ${
                                            done
                                                ? "text-gold"
                                                : active
                                                  ? "text-gold/80"
                                                  : "text-cream/45"
                                        }`}
                                    >
                                        {s.status}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
